import { IsNotEmpty } from "class-validator";
import { IBase, IOrderCancelReason } from "../../interfaces";

export class OrderCancelReasonDTO implements Omit<IOrderCancelReason, keyof IBase> {
  @IsNotEmpty({ message: 'La raison est requise' })
  reason: string;
}
